// extracted by mini-css-extract-plugin
module.exports = {"productType":"styles_productType__GFMgZ"};